import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=c0ecb5bc&scoped=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=c0ecb5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ecb5bc",
  null
  
)

export default component.exports